module.exports = __webpack_public_path__ + "media/images/flags/4x3/ggy-4c6152c30643993e15c69e9002b48c2e.svg";